"use client";
import Image from "next/image";

const ClientImage = ({ image, imageFill = true }) => {
    const {mediaDetails, mediaItemUrl, altText} = image?.node || {};
      if(!image?.node?.mediaItemUrl) return false;

    return (
        <Image
            priority
            className={imageFill ? "image_fill" : undefined}
            width={mediaDetails?.width || "50"}
            height={mediaDetails?.height || "50"}
            alt={altText || "An Image"}
            src={mediaItemUrl}
        />
    );
};

export default ClientImage;